const apiBaseUrl = (process.env.REACT_APP_RSVP_API_BASE_URL || 'http://localhost:8000').replace(/\/$/, '');

function createIdempotencyKey() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const random = Math.floor(Math.random() * 16);
    const value = character === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

async function getRsvpFormToken() {
  const response = await fetch(`${apiBaseUrl}/api/v1/rsvps`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok || typeof body.formToken !== 'string' || !body.formToken) {
    throw new Error('form_token_unavailable');
  }
  return body.formToken;
}

async function submitRsvp(payload, idempotencyKey = createIdempotencyKey(), formToken = '') {
  const response = await fetch(`${apiBaseUrl}/api/v1/rsvps`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...payload, idempotencyKey, formToken }),
  });

  let body = null;
  try {
    body = await response.json();
  } catch (_error) {
    // The UI supplies a localized generic message for malformed responses.
  }

  if (!response.ok) {
    const error = new Error(body?.error?.code || 'request_failed');
    error.status = response.status;
    error.details = body?.error;
    throw error;
  }

  return { result: body, idempotencyKey };
}

export { createIdempotencyKey, getRsvpFormToken, submitRsvp };
